








import { Component, Vue } from 'vue-property-decorator';
import SettingsNav from '@/components/SettingsNav.vue';

@Component({
    components: {
        SettingsNav,
    },
})
export default class Settings extends Vue {
    private created() {
        this.$store.state.btnSidebarVisible = true;
    }

    private showHideSidebar() {
        if (this.$store.state.mobileSidebarVisible === true) {
            this.$store.state.mobileSidebarVisible = false;
        } else {
            this.$store.state.mobileSidebarVisible = true;
        }
    }
}
